module.exports = {"360281001":"洎阳街道","360281002":"塔山街道","360281100":"镇桥镇","360281101":"乐港镇","360281102":"涌山镇","360281103":"众埠镇","360281104":"接渡镇","360281105":"洪岩镇","360281106":"礼林镇","360281107":"后港镇","360281108":"塔前镇","360281109":"双田镇","360281110":"临港镇","360281111":"高家镇","360281112":"名口镇","360281113":"浯口镇","360281114":"十里岗镇","360281200":"鸬鹚乡","360281400":"农业高新园","360281401":"江西乐平工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360281.json
// module id = 1161
// module chunks = 0